import clsx from "clsx";

export function CheckboxIcon({ checked }: { checked: boolean }) {
  return (
    <div className="flex size-[24px] shrink-0 items-center justify-center">
      <div
        className={clsx(
          "flex size-[16px] items-center justify-center rounded-[3px] border",
          checked
            ? "border-sorange bg-sorange"
            : "border-skogecha-60 bg-swhite",
        )}
      >
        {checked && (
          <svg width="10" height="8" viewBox="0 0 14 10" fill="none">
            <path
              d="M1 5L5 9L13 1"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
      </div>
    </div>
  );
}
